import { Placeholder } from '../Placeholder';
export default function SystemOverviewPage(): JSX.Element {
  return <Placeholder screenNo="1" title="시스템 전체 지표" description="손익/성과/시스템 건강 상태. 후속 구현." />;
}
